import { SaleApi, BovineApi } from '../../../services/api';
import {
    formatZipCode,
    formatCPF,
    formatCNPJ,
    formatPhone,
    formatCellPhone,
    roundNumber,
} from '../../../lib/helpers';
import { getGeneralCalculationType } from '../../../lib/sales';
import { getFormData } from './types';

const formatBuyer = (buyer) => {
    let { document } = buyer;
    if (document && document.length === 14) {
        document = formatCNPJ(document);
    } else if (document) {
        document = formatCPF(document);
    }

    const birthDate = buyer.birthDate ? new Date(buyer.birthDate) : null;
    const phone = buyer.phone ? formatPhone(buyer.phone) : '';
    const cellPhone = buyer.cellPhone ? formatCellPhone(buyer.cellPhone) : '';
    const zipCode = buyer?.address?.zipCode ? formatZipCode(buyer?.address?.zipCode) : '';

    return {
        ...buyer,
        birthDate,
        document,
        phone,
        cellPhone,
        address: {
            ...(buyer.address || {}),
            zipCode,
        },
    }
};

export default {
    clearForm({ commit, state }) {
        if (state.isRedoing) {
            commit('setIsRedoing', false);
            return;
        }
        commit('clearForm');
    },
    async fetchSale({ commit }, id) {
        try {
            commit('setLoadingFetch', true);
            const sale = await SaleApi.fetchById(id);
            const data = {
                ...sale,
                date: sale.date ? new Date(sale.date) : null,
                buyer: formatBuyer(sale.buyer || {}),
            };
            commit('setFormData', data);
        } finally {
            commit('setLoadingFetch', false);
        }
    },
    setBuyer({ commit, state }, buyer) {
        const data = {
            ...state.formData.buyer,
            ...formatBuyer(buyer),
        };
        commit('setBuyer', data);
    },
    setBuyerAdress({ commit, state }, address) {
        commit('setBuyerAdress', { ...state.formData.buyer.address, ...address });
    },
    addBovines({ commit, state }, bovines) {
        const saleBovine = bovines.map((bovine) => ({
            bovineId: bovine.id,
            calculationTypeId: 1,
            weight: Number(bovine.weight) || 0,
            value: null,
            arrobaWeight: 30,
            bovine,
        }));
        commit('setBovines', [...state.formData.bovines, ...saleBovine]);
    },
    removeBovine({ commit, state }, id) {
        const bovines = state.formData.bovines.filter((bovine) => bovine.bovineId !== id);
        commit('setBovines', bovines);
    },
    create({ state }) {
        const data = {
            ...state.formData,
            bovines: state.formData.bovines.map((saleBovine) => {
                return { ...saleBovine, bovine: undefined };
            }),
        };
        return SaleApi.create(data);
    },
    update({ state }) {
        const data = {
            invoice: state.formData.invoice,
            date: state.formData.date,
            observation: state.formData.observation,
        };
        return SaleApi.update(state.formData.id, data);
    },
    updateStatus({ state }, statusId) {
        const data = { statusId };
        return SaleApi.update(state.formData.id, data);
    },
    delete({ state }) {
        return SaleApi.delete(state.formData.id);
    },
    async saveBovineWeight({ state, commit }, { bovineId, weight }) {
        await BovineApi.patch(bovineId, { weight });
        const bovines = state.formData.bovines.map((saleBovine) => {
            if (saleBovine.bovineId === bovineId) {
                saleBovine.bovine.weight = weight;
            }
            return saleBovine;
        });
        commit('setBovines', bovines);
    },
    applyGeneralValue({ state, commit }) {
        const bovines = state.formData.bovines.map((saleBovine) => {
            const updatedSaleBovine = {
                ...saleBovine,
                calculationTypeId: getGeneralCalculationType(state.formData.generalValue.typeId),
                arrobaWeight: state.formData.generalValue.arrobaWeight,
            };

            // Valida tipo por valor total da venda
            if (state.formData.generalValue.typeId === 4) {
                updatedSaleBovine.value = roundNumber(state.formData.generalValue.value / state.formData.bovines.length);
            } else {
                updatedSaleBovine.value = state.formData.generalValue.value;
            }

            return updatedSaleBovine;
        });

        // Acrescenta a diferença ao valor do bovino para o valor final ser igual ao informado.
        if (state.formData.generalValue.value && state.formData.generalValue.typeId === 4) {
            const expectedValue = state.formData.generalValue.value;
            const currentValue = roundNumber(bovines.reduce((total, next) => total + next.value, 0));
            const diff = roundNumber(expectedValue - currentValue);
            console.log('value diff', diff);
            bovines[0].value += diff;
        }

        commit('setBovines', bovines);
    },
    redoSale({ commit, state }) {
        const formData = getFormData();
        const data = {
            ...formData,
            ...state.formData,
        };

        delete data.id;
        delete data.statusId;
        delete data.createdAt;
        delete data.createdBy;
        delete data.updatedAt;
        delete data.updatedBy;

        commit('setFormData', data);
        commit('setIsRedoing', true);
    }
};
